import { render, staticRenderFns } from "./PixelContent.vue?vue&type=template&id=391135fa&scoped=true&"
import script from "./PixelContent.vue?vue&type=script&lang=js&"
export * from "./PixelContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391135fa",
  null
  
)

export default component.exports